import { Col, Row, Space } from "antd";
import { FC } from "react";
import { LogTextStatus } from "../../../../components/logText";
import SimpleCard from "../../../../components/simpleCard";
import LeasingStore from "../../../../contexts/leasingStore";
import UserStore from "../../../../contexts/userStore";
import _t from "../../../../lang/translate";
import LeasingGenerateBailDocument from "../leasingGenerateBailDocument";
import LeasingGenerateChecklist from "../leasingGenerateChecklist";
import LeasingGeneratePaymentAdviceFirstTimeDocument from "../leasingGeneratePaymentAdviceFirstTime";
import LeasingAdminContractsInfo from "./leasingAdminContrctsInfo";
import OpenContractsButton from "./openContractsButton";
import StartDigitalSigningButton from "./startDigitalSigningButton";

const LeasingAdminContract: FC = () => {
  const { hasPermission } = UserStore.useContainer();
  const { leasingCase, adminValues } = LeasingStore.useContainer();
  const { log, partnerCase } = leasingCase;
  const canReopenContract = hasPermission(partnerCase ? "partner_leasing.reopen_contract" : "leasing.reopen_contract");
  return (
    <>
      <SimpleCard title={_t("contract_handling")}>
        <LogTextStatus log={log?.contractGenerated}
          defaultLabel={_t("contracts_not_generated")}
          logLabel={_t("contracts_generated")}
          by className="mb-05"
        />
        <LogTextStatus log={adminValues?.logs?.digitalSigningCreated}
          defaultLabel="Afventer afsendelse af digital underskrift"
          logLabel={"Digital underskrift signeret"}
          className="mb-05"
          by
        />
        <Row className="mt-05" justify="space-between">
          <Col>
            <Space>
              <LeasingAdminContractsInfo />
              {canReopenContract && <OpenContractsButton />}
            </Space>
          </Col>
          <Col>
            <StartDigitalSigningButton />
          </Col>
        </Row>
      </SimpleCard>

      <SimpleCard title={_t("advice")}>
        <LogTextStatus log={adminValues?.logs?.firstTimePaymentAdviceSent}
          defaultLabel="Afventer afsendelse af udbetalingsadvis"
          logLabel={"Udbetalingsadvis afsendt"}
          className="mb-05" by
        />
        <LeasingGeneratePaymentAdviceFirstTimeDocument />
      </SimpleCard>

      <SimpleCard className="mb-0" title={_t("documents")}>
        <Space size='small'>
          <LeasingGenerateBailDocument />
          <LeasingGenerateChecklist />
        </Space>
      </SimpleCard>
    </>
  );
};

export default LeasingAdminContract;
